import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './api-error'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          // 429/408 SÃO 4xx e SÃO retryáveis — a regra "não retry em 4xx" tem exceções.
          if (error.status === 408 || error.status === 429) return failureCount < 2
          // 401/403/404/409/413/422 são determinísticos: repetir só gasta banda.
          if (error.status >= 400 && error.status < 500) return false
        }
        return failureCount < 2
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      // App financeiro: saldo velho é pior que um GET a mais.
      refetchOnWindowFocus: true,
    },
    mutations: {
      /**
       * NUNCA auto-retry.
       *
       * As 8 rotas de efeito financeiro só são seguras com a MESMA
       * Idempotency-Key, e o retry do Query re-executa o mutationFn — que é
       * exatamente onde uma chave nova seria gerada se o autor descuidar.
       * Retry aqui é manual, reusando a chave da intenção.
       */
      retry: false,
    },
  },
})
